import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { palette } from "./palette";
import { merge } from "lodash";
import { CssBaseline, ThemeProvider, createTheme, } from "@mui/material";
import { componentsOverrides } from "./overrides";
import { customShadows } from "./custom-shadows";
import { shadows } from "./shadows";
import { typography } from "./typography";
import { useQuietMotion } from "./use-quiet-motion";
export default function CustomThemeProvider({ children }) {
    const quietMotion = useQuietMotion();
    const baseOption = useMemo(() => ({
        palette: palette("light"),
        shadows: shadows("light"),
        customShadows: customShadows("light"),
        typography,
        shape: { borderRadius: 8 },
    }), []);
    const memoizedValue = useMemo(() => merge(
    // Base
    baseOption), [baseOption]);
    const theme = useMemo(() => {
        const nextTheme = createTheme(memoizedValue);
        nextTheme.components = componentsOverrides(nextTheme, quietMotion);
        return nextTheme;
    }, [memoizedValue, quietMotion]);
    return (_jsxs(ThemeProvider, { theme: theme, children: [_jsx(CssBaseline, {}), children] }));
}
